import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MappingItemIdIndexType, UserType } from '../../types';

export interface IUserState {
    currentItem: UserType | null;
    isItemEdit: boolean;
    mappingItemIdIndex: MappingItemIdIndexType;
    externalFetchKey: number;
}

const initialState: IUserState = {
    currentItem: null,
    isItemEdit: false,
    mappingItemIdIndex: {},
    externalFetchKey: 0,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setterUser: (state, action: PayloadAction<Partial<IUserState>>) => ({
            ...state,
            ...action.payload,
        }),
    },
});

export const { setterUser } = userSlice.actions;

export default userSlice.reducer;
